import qs from 'qs';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const getNavbarConfig = () => axiosInstance.get('/general/navbar', { params: pickDevParams });

export const getNavbarCounters = (params) => axiosInstance.get('/general/get-navbar-counters', { params });

export const switchViewModeUrl = (mode) => axiosInstance.post('/general/dark-mode', qs.stringify({ mode, ...pickDevParams }));

export const getServicesList = () => axiosInstance.get('/services/list-all', { params: pickDevParams });

export const getGuidesList = (payload) => axiosInstance.get('/guides/list', { params: { ...payload, ...pickDevParams } });

export const getCDNToken = (payload) => axiosInstance.get('/general/cdn-token', { params: { ...payload, ...pickDevParams } });

export const changePassword = (payload) => axiosInstance.post('/account/save', { ...payload, ...pickDevParams });
